import { Link } from '@tanstack/react-router'

import { siteConfig } from '@/config/site'
import { Container } from '@/components/common/container'
import { Button } from '@/components/ui/button'
import { DesktopNav } from '@/components/layout/desktop-nav'
import { MobileNav } from '@/components/layout/mobile-nav'
import { ThemeSwitch } from '@/components/layout/theme-switch'

function Header() {
  return (
    <header className="border-border bg-background/80 sticky top-0 z-40 border-b backdrop-blur-md">
      <Container className="flex h-14 items-center justify-between gap-4">
        <Link to="/" className="text-foreground text-sm font-semibold tracking-tight">
          {siteConfig.name}
        </Link>

        <DesktopNav />

        <div className="flex items-center gap-2">
          <ThemeSwitch />
          <Button asChild size="sm" className="hidden sm:inline-flex">
            <Link to={'/play' as never}>Play now</Link>
          </Button>
          <MobileNav />
        </div>
      </Container>
    </header>
  )
}

export { Header }
